import aboutImageUrl from '../assets/images/about_bg.jpg';
import aboutImageMobileUrl from '../assets/images/about_bg_mobile.jpg';
import bankPlaceholderUrl from '../assets/images/BankPlaceholder.png';
import completedUrl from '../assets/images/Completed.png';
import countryAD from '../assets/images/countries/AD.png';
import countryAE from '../assets/images/countries/AE.png';
import countryAF from '../assets/images/countries/AF.png';
import countryAG from '../assets/images/countries/AG.png';
import countryAI from '../assets/images/countries/AI.png';
import countryAL from '../assets/images/countries/AL.png';
import countryAM from '../assets/images/countries/AM.png';
import countryAN from '../assets/images/countries/AN.png';
import countryAO from '../assets/images/countries/AO.png';
import countryAR from '../assets/images/countries/AR.png';
import countryAT from '../assets/images/countries/AT.png';
import countryAU from '../assets/images/countries/AU.png';
import countryAW from '../assets/images/countries/AW.png';
import countryAZ from '../assets/images/countries/AZ.png';
import countryBA from '../assets/images/countries/BA.png';
import countryBB from '../assets/images/countries/BB.png';
import countryBD from '../assets/images/countries/BD.png';
import countryBE from '../assets/images/countries/BE.png';
import countryBF from '../assets/images/countries/BF.png';
import countryBG from '../assets/images/countries/BG.png';
import countryBH from '../assets/images/countries/BH.png';
import countryBI from '../assets/images/countries/BI.png';
import countryBJ from '../assets/images/countries/BJ.png';
import countryBM from '../assets/images/countries/BM.png';
import countryBN from '../assets/images/countries/BN.png';
import countryBO from '../assets/images/countries/BO.png';
import countryBR from '../assets/images/countries/BR.png';
import countryBS from '../assets/images/countries/BS.png';
import countryBT from '../assets/images/countries/BT.png';
import countryBW from '../assets/images/countries/BW.png';
import countryBY from '../assets/images/countries/BY.png';
import countryBZ from '../assets/images/countries/BZ.png';
import countryCA from '../assets/images/countries/CA.png';
import countryCD from '../assets/images/countries/CD.png';
import countryCF from '../assets/images/countries/CF.png';
import countryCG from '../assets/images/countries/CG.png';
import countryCH from '../assets/images/countries/CH.png';
import countryCI from '../assets/images/countries/CI.png';
import countryCK from '../assets/images/countries/CK.png';
import countryCL from '../assets/images/countries/CL.png';
import countryCM from '../assets/images/countries/CM.png';
import countryCN from '../assets/images/countries/CN.png';
import countryCO from '../assets/images/countries/CO.png';
import countryCR from '../assets/images/countries/CR.png';
import countryCV from '../assets/images/countries/CV.png';
import countryCY from '../assets/images/countries/CY.png';
import countryCZ from '../assets/images/countries/CZ.png';
import countryDE from '../assets/images/countries/DE.png';
import countryDJ from '../assets/images/countries/DJ.png';
import countryDK from '../assets/images/countries/DK.png';
import countryDM from '../assets/images/countries/DM.png';
import countryDO from '../assets/images/countries/DO.png';
import countryDZ from '../assets/images/countries/DZ.png';
import countryEC from '../assets/images/countries/EC.png';
import countryEE from '../assets/images/countries/EE.png';
import countryEG from '../assets/images/countries/EG.png';
import countryES from '../assets/images/countries/ES.png';
import countryET from '../assets/images/countries/ET.png';
import countryFI from '../assets/images/countries/FI.png';
import countryFJ from '../assets/images/countries/FJ.png';
import countryFO from '../assets/images/countries/FO.png';
import countryFR from '../assets/images/countries/FR.png';
import countryGA from '../assets/images/countries/GA.png';
import countryGB from '../assets/images/countries/GB.png';
import countryGD from '../assets/images/countries/GD.png';
import countryGE from '../assets/images/countries/GE.png';
import countryGF from '../assets/images/countries/GF.png';
import countryGH from '../assets/images/countries/GH.png';
import countryGI from '../assets/images/countries/GI.png';
import countryGL from '../assets/images/countries/GL.png';
import countryGM from '../assets/images/countries/GM.png';
import countryGN from '../assets/images/countries/GN.png';
import countryGP from '../assets/images/countries/GP.png';
import countryGQ from '../assets/images/countries/GQ.png';
import countryGR from '../assets/images/countries/GR.png';
import countryGT from '../assets/images/countries/GT.png';
import countryGU from '../assets/images/countries/GU.png';
import countryGW from '../assets/images/countries/GW.png';
import countryGY from '../assets/images/countries/GY.png';
import countryHK from '../assets/images/countries/HK.png';
import countryHN from '../assets/images/countries/HN.png';
import countryHR from '../assets/images/countries/HR.png';
import countryHT from '../assets/images/countries/HT.png';
import countryHU from '../assets/images/countries/HU.png';
import countryID from '../assets/images/countries/ID.png';
import countryIE from '../assets/images/countries/IE.png';
import countryIL from '../assets/images/countries/IL.png';
import countryIN from '../assets/images/countries/IN.png';
import countryIQ from '../assets/images/countries/IQ.png';
import countryIS from '../assets/images/countries/IS.png';
import countryIT from '../assets/images/countries/IT.png';
import countryJM from '../assets/images/countries/JM.png';
import countryJO from '../assets/images/countries/JO.png';
import countryJP from '../assets/images/countries/JP.png';
import countryKE from '../assets/images/countries/KE.png';
import countryKG from '../assets/images/countries/KG.png';
import countryKH from '../assets/images/countries/KH.png';
import countryKI from '../assets/images/countries/KI.png';
import countryKM from '../assets/images/countries/KM.png';
import countryKN from '../assets/images/countries/KN.png';
import countryKR from '../assets/images/countries/KR.png';
import countryKW from '../assets/images/countries/KW.png';
import countryKY from '../assets/images/countries/KY.png';
import countryKZ from '../assets/images/countries/KZ.png';
import countryLA from '../assets/images/countries/LA.png';
import countryLB from '../assets/images/countries/LB.png';
import countryLC from '../assets/images/countries/LC.png';
import countryLI from '../assets/images/countries/LI.png';
import countryLK from '../assets/images/countries/LK.png';
import countryLR from '../assets/images/countries/LR.png';
import countryLS from '../assets/images/countries/LS.png';
import countryLT from '../assets/images/countries/LT.png';
import countryLU from '../assets/images/countries/LU.png';
import countryLV from '../assets/images/countries/LV.png';
import countryLY from '../assets/images/countries/LY.png';
import countryMA from '../assets/images/countries/MA.png';
import countryMC from '../assets/images/countries/MC.png';
import countryMD from '../assets/images/countries/MD.png';
import countryME from '../assets/images/countries/ME.png';
import countryMG from '../assets/images/countries/MG.png';
import countryMK from '../assets/images/countries/MK.png';
import countryML from '../assets/images/countries/ML.png';
import countryMM from '../assets/images/countries/MM.png';
import countryMN from '../assets/images/countries/MN.png';
import countryMO from '../assets/images/countries/MO.png';
import countryMQ from '../assets/images/countries/MQ.png';
import countryMR from '../assets/images/countries/MR.png';
import countryMS from '../assets/images/countries/MS.png';
import countryMT from '../assets/images/countries/MT.png';
import countryMU from '../assets/images/countries/MU.png';
import countryMV from '../assets/images/countries/MV.png';
import countryMW from '../assets/images/countries/MW.png';
import countryMX from '../assets/images/countries/MX.png';
import countryMY from '../assets/images/countries/MY.png';
import countryMZ from '../assets/images/countries/MZ.png';
import countryNA from '../assets/images/countries/NA.png';
import countryNC from '../assets/images/countries/NC.png';
import countryNE from '../assets/images/countries/NE.png';
import countryNG from '../assets/images/countries/NG.png';
import countryNI from '../assets/images/countries/NI.png';
import countryNL from '../assets/images/countries/NL.png';
import countryNO from '../assets/images/countries/NO.png';
import countryNP from '../assets/images/countries/NP.png';
import countryNZ from '../assets/images/countries/NZ.png';
import countryOM from '../assets/images/countries/OM.png';
import countryPA from '../assets/images/countries/PA.png';
import countryPE from '../assets/images/countries/PE.png';
import countryPG from '../assets/images/countries/PG.png';
import countryPH from '../assets/images/countries/PH.png';
import countryPK from '../assets/images/countries/PK.png';
import countryPL from '../assets/images/countries/PL.png';
import countryPR from '../assets/images/countries/PR.png';
import countryPS from '../assets/images/countries/PS.png';
import countryPT from '../assets/images/countries/PT.png';
import countryPW from '../assets/images/countries/PW.png';
import countryPY from '../assets/images/countries/PY.png';
import countryQA from '../assets/images/countries/QA.png';
import countryRE from '../assets/images/countries/RE.png';
import countryRO from '../assets/images/countries/RO.png';
import countryRS from '../assets/images/countries/RS.png';
import countryRU from '../assets/images/countries/RU.png';
import countryRW from '../assets/images/countries/RW.png';
import countrySA from '../assets/images/countries/SA.png';
import countrySB from '../assets/images/countries/SB.png';
import countrySC from '../assets/images/countries/SC.png';
import countrySE from '../assets/images/countries/SE.png';
import countrySG from '../assets/images/countries/SG.png';
import countrySI from '../assets/images/countries/SI.png';
import countrySK from '../assets/images/countries/SK.png';
import countrySL from '../assets/images/countries/SL.png';
import countrySN from '../assets/images/countries/SN.png';
import countrySO from '../assets/images/countries/SO.png';
import countrySR from '../assets/images/countries/SR.png';
import countrySS from '../assets/images/countries/SS.png';
import countryST from '../assets/images/countries/ST.png';
import countrySV from '../assets/images/countries/SV.png';
import countrySZ from '../assets/images/countries/SZ.png';
import countryTC from '../assets/images/countries/TC.png';
import countryTD from '../assets/images/countries/TD.png';
import countryTG from '../assets/images/countries/TG.png';
import countryTH from '../assets/images/countries/TH.png';
import countryTJ from '../assets/images/countries/TJ.png';
import countryTL from '../assets/images/countries/TL.png';
import countryTM from '../assets/images/countries/TM.png';
import countryTN from '../assets/images/countries/TN.png';
import countryTO from '../assets/images/countries/TO.png';
import countryTR from '../assets/images/countries/TR.png';
import countryTT from '../assets/images/countries/TT.png';
import countryTW from '../assets/images/countries/TW.png';
import countryTZ from '../assets/images/countries/TZ.png';
import countryUA from '../assets/images/countries/UA.png';
import countryUG from '../assets/images/countries/UG.png';
import countryUS from '../assets/images/countries/US.png';
import countryUY from '../assets/images/countries/UY.png';
import countryUZ from '../assets/images/countries/UZ.png';
import countryVC from '../assets/images/countries/VC.png';
import countryVE from '../assets/images/countries/VE.png';
import countryVG from '../assets/images/countries/VG.png';
import countryVI from '../assets/images/countries/VI.png';
import countryVN from '../assets/images/countries/VN.png';
import countryVU from '../assets/images/countries/VU.png';
import countryWS from '../assets/images/countries/WS.png';
import countryXK from '../assets/images/countries/XK.png';
import countryYE from '../assets/images/countries/YE.png';
import countryZA from '../assets/images/countries/ZA.png';
import countryZM from '../assets/images/countries/ZM.png';
import countryZW from '../assets/images/countries/ZW.png';
import defaultOfferingUrl from '../assets/images/DefaultOffering.png';
import homeBackgroundUrl from '../assets/images/home_background.jpg';
import homeBackgroundWideUrl from '../assets/images/home_background_wide.jpg';
import myIPOLogoUrl from '../assets/images/logo.png';
import logoUrl from '../assets/images/logo_header.png';
import myIPOLogoSVGUrl from '../assets/images/logo_header_svg.svg';
import mobileNavUrl from '../assets/images/mobile_nav.png';
import noIndicationsUrl from '../assets/images/NoIndications.png';
import reloadIconUrl from '../assets/images/ReloadIcon.png';
import sortUrl from '../assets/images/Sort.png';
import sortIconActiveUrl from '../assets/images/SortIconActive.png';
import playMediumUrl from '../assets/images/videoPlay.png';
import playSmallUrl from '../assets/images/videoPlay@2x.png';

export namespace Image {
  export const About = aboutImageUrl;
  export const AboutMobile = aboutImageMobileUrl;
  export const HomeBackground = homeBackgroundUrl;
  export const HomeBackgroundWide = homeBackgroundWideUrl;
  export const MyIPOLogo = myIPOLogoUrl;
  export const MyIPOLogoSVG = myIPOLogoSVGUrl;
  export const Logo = logoUrl;
  export const MobileNav = mobileNavUrl;
  export const PlayMedium = playMediumUrl;
  export const PlaySmall = playSmallUrl;
  export const DefaultOffering = defaultOfferingUrl;
  export const NoIndications = noIndicationsUrl;
  export const Sort = sortUrl;
  export const SortIconActive = sortIconActiveUrl;
  export const Completed = completedUrl;
  export const BankPlaceholder = bankPlaceholderUrl;
  export const ReloadIcon = reloadIconUrl;
  export const Country = {
    AT: countryAT,
    AR: countryAR,
    AU: countryAU,
    AF: countryAF,
    DZ: countryDZ,
    AO: countryAO,
    AW: countryAW,
    AL: countryAL,
    AM: countryAM,
    AD: countryAD,
    AZ: countryAZ,
    AI: countryAI,
    AG: countryAG,
    BS: countryBS,
    BH: countryBH,
    BD: countryBD,
    BB: countryBB,
    BY: countryBY,
    BE: countryBE,
    BZ: countryBZ,
    BJ: countryBJ,
    BM: countryBM,
    BT: countryBT,
    BO: countryBO,
    BA: countryBA,
    BW: countryBW,
    BR: countryBR,
    BN: countryBN,
    BG: countryBG,
    BF: countryBF,
    BI: countryBI,
    KH: countryKH,
    CM: countryCM,
    CA: countryCA,
    CV: countryCV,
    KY: countryKY,
    CF: countryCF,
    TD: countryTD,
    CL: countryCL,
    CN: countryCN,
    CO: countryCO,
    KM: countryKM,
    CK: countryCK,
    CR: countryCR,
    HR: countryHR,
    CY: countryCY,
    CZ: countryCZ,
    CD: countryCD,
    DK: countryDK,
    DJ: countryDJ,
    DM: countryDM,
    DO: countryDO,
    EC: countryEC,
    EG: countryEG,
    SV: countrySV,
    GQ: countryGQ,
    EE: countryEE,
    ET: countryET,
    FO: countryFO,
    FJ: countryFJ,
    FI: countryFI,
    FR: countryFR,
    GF: countryGF,
    GA: countryGA,
    GM: countryGM,
    GE: countryGE,
    DE: countryDE,
    GH: countryGH,
    GI: countryGI,
    GR: countryGR,
    GL: countryGL,
    GD: countryGD,
    GP: countryGP,
    GU: countryGU,
    GT: countryGT,
    GN: countryGN,
    GW: countryGW,
    GY: countryGY,
    HT: countryHT,
    HN: countryHN,
    HK: countryHK,
    HU: countryHU,
    IS: countryIS,
    IN: countryIN,
    ID: countryID,
    IQ: countryIQ,
    IE: countryIE,
    IL: countryIL,
    IT: countryIT,
    CI: countryCI,
    JM: countryJM,
    JP: countryJP,
    JO: countryJO,
    KZ: countryKZ,
    KE: countryKE,
    KI: countryKI,
    KW: countryKW,
    KG: countryKG,
    LA: countryLA,
    LV: countryLV,
    LB: countryLB,
    LS: countryLS,
    LR: countryLR,
    LY: countryLY,
    LI: countryLI,
    LT: countryLT,
    LU: countryLU,
    MO: countryMO,
    MG: countryMG,
    MW: countryMW,
    MY: countryMY,
    MV: countryMV,
    ML: countryML,
    MT: countryMT,
    MQ: countryMQ,
    MR: countryMR,
    MU: countryMU,
    MX: countryMX,
    MD: countryMD,
    MC: countryMC,
    MN: countryMN,
    ME: countryME,
    MS: countryMS,
    MA: countryMA,
    MZ: countryMZ,
    MM: countryMM,
    NA: countryNA,
    NP: countryNP,
    NL: countryNL,
    AN: countryAN,
    NC: countryNC,
    NZ: countryNZ,
    NI: countryNI,
    NE: countryNE,
    NG: countryNG,
    MK: countryMK,
    NO: countryNO,
    OM: countryOM,
    PK: countryPK,
    PW: countryPW,
    PS: countryPS,
    PA: countryPA,
    PG: countryPG,
    PY: countryPY,
    PE: countryPE,
    PH: countryPH,
    PL: countryPL,
    PT: countryPT,
    PR: countryPR,
    QA: countryQA,
    CG: countryCG,
    RE: countryRE,
    RO: countryRO,
    RU: countryRU,
    RW: countryRW,
    KN: countryKN,
    LC: countryLC,
    VC: countryVC,
    WS: countryWS,
    ST: countryST,
    SA: countrySA,
    SN: countrySN,
    RS: countryRS,
    SC: countrySC,
    SL: countrySL,
    SG: countrySG,
    SK: countrySK,
    SI: countrySI,
    SB: countrySB,
    SO: countrySO,
    ZA: countryZA,
    KR: countryKR,
    SS: countrySS,
    ES: countryES,
    LK: countryLK,
    SR: countrySR,
    SZ: countrySZ,
    SE: countrySE,
    CH: countryCH,
    TW: countryTW,
    TJ: countryTJ,
    TZ: countryTZ,
    TH: countryTH,
    TL: countryTL,
    TG: countryTG,
    TO: countryTO,
    TT: countryTT,
    TN: countryTN,
    TR: countryTR,
    TM: countryTM,
    TC: countryTC,
    UG: countryUG,
    UA: countryUA,
    AE: countryAE,
    GB: countryGB,
    US: countryUS,
    UY: countryUY,
    UZ: countryUZ,
    VU: countryVU,
    VE: countryVE,
    VN: countryVN,
    VG: countryVG,
    VI: countryVI,
    XK: countryXK,
    YE: countryYE,
    ZM: countryZM,
    ZW: countryZW,
  };
}
